import { useNavigate } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { SystemMessageLayout } from '../ui/SystemMessageLayout';

export function Forbidden() {
  const navigate = useNavigate();

  return (
    <SystemMessageLayout
      statusCode={403}
      icon={<ShieldAlert className="w-12 h-12 text-warning-500" strokeWidth={1.5} />}
      title="Access Denied"
      description="You don't have permission to view this page or perform this action. If you believe this is a mistake, contact your administrator."
      action={{
        label: 'Return to Dashboard',
        onClick: () => navigate({ to: '/' }),
      }}
    />
  );
}
